export default class ApiCall {

    private url = "" + process.env.REACT_APP_API_URL

    /********************************************************************************\
        this file as to goal to generalize all the api call
        @Params:
            route: string
                Route souhaité sur l'api (exemple: Login, removeAccessToken)
            
            method: strin&g
                "GET", "POST", "DELETE", "PATCH" ...
            
            bodyParams: {}
                Body of your request. Your body can be JSON
            
            token: string OR null (OPTIONNAL)
                AccesToken OR RefreshToken for API.
                JWT (JSON Web Token)

    \********************************************************************************/

    async ApiCall(route: string, method: string, bodyParams: {}, token: string | null = "") {
        try {
            if (method === "GET") {
                return (this.Getrequest(route, localStorage.getItem('AccessToken')))
            }
            let headers:any = localStorage.getItem('AccessToken') === null 
                ? { 'Content-Type': 'application/json'}
                : { 'Content-Type': 'application/json',
                'authorization': "Bearer "  + localStorage.getItem('AccessToken')}
            var requestOptions = {
                method: method,
                headers: headers,
                body: JSON.stringify(bodyParams)
            };
            const request = await fetch(this.url + route, requestOptions)
            const result = await request.status
            try {
                const body = await request.json()
                return ({
                    "status": result,
                    "data": body
                })
            } catch (error) {
                return ({
                    "status": result,
                    "data": ""
                })
            }
        } catch (error) {
            console.log(error)
            return ({
                "status": 500,
                "data": []
            })
        }
    }

    async Getrequest(route: string, token: string | null = "") {
        try {
            let headers:any = localStorage.getItem('AccessToken') === null 
                ? { 'Content-Type': 'application/json'}
                : { 'Content-Type': 'application/json',
                'authorization': "Bearer "  + localStorage.getItem('AccessToken')}

            var requestOptions = {
                method: "GET",
                headers: headers
            };
            const request = await fetch(this.url + route, requestOptions)
            const result = await request.status
            const body = await request.json()
            return ({
                "status": result,
                "data": body
            })
        } catch (error) {
            return ({
                "status": 500,
                "data": []
            })
        }
    }

}